import React from 'react'
import { TableRow, TableCell, CircularProgress } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'
import { CoreButton } from 'src/components/core'
import { withStyles } from '@material-ui/core'
import styles from './styles'
const RootTableCellButton = styled(TableCell)(() => ({
  backgroundColor: '#F4F6F8',
  textAlign: 'center',
}))

const BottomUpgradeButtons = props => {
  const { plans, handleClick, classes, category, loading } = props
  return (
    <TableRow>
      <RootTableCellButton className={classes.cellWide}></RootTableCellButton>
      {plans.map((item, index) => (
        <RootTableCellButton>
          <CoreButton
            fullWidth
            size="large"
            color={item.action.active === true ? 'secondary' : 'primary'}
            variant={item.action.active === true ? 'text' : 'contained'}
            className={
              category.visible === true ? classes.visible : classes.hidden
            }
            disabled={item.action.disabled === true || loading}
            onClick={() => {
              handleClick(item)
            }}
            href={
              index === 3 &&
              'https://calendly.com/minicoursegenerator/30min?month=2023-08'
            }
            target="_blank"
          >
            {loading && item.action.disabled !== true ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              item.action.tableText
            )}
          </CoreButton>
        </RootTableCellButton>
      ))}
    </TableRow>
  )
}

export default withStyles(styles)(BottomUpgradeButtons)
